import type { ApiResponse } from '@/types/site';
import { XHRClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export interface LoginRequest {
  loginId: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  user: {
    id: string;
    loginId: string;
    name: string;
    userLevel: string;
  };
}

export const login = async (
  loginData: LoginRequest
): Promise<LoginResponse> => {
  const response = await XHRClient.post<ApiResponse<LoginResponse>>(
    ENDPOINTS.auth.login,
    loginData
  );

  return response.data.data;
};
